function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#5E599C",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10,1 C15,1 19,5 19,10 C19,15 15,19 10,19 C5,19 1,15 1,10 C1,5 5,1 10,1 Z M10,0 C4.5,0 0,4.5 0,10 C0,15.5 4.5,20 10,20 C15.5,20 20,15.5 20,10 C20,4.5 15.5,0 10,0 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11,3.79993 C10.6999989,3.79993 10.5,3.89996 10.3000002,4.09998 C10.1000004,4.29993 10,4.59998 9.8999996,4.89996 C9.8999996,5.19995 10.000001,5.49988 10.2000008,5.69995 C10.3999996,5.89996 10.7000008,5.99988 11.000001,5.99988 C11.3000002,5.99988 11.500001,5.89996 11.7000008,5.69995 C11.9000006,5.49988 12.000001,5.19995 12.000001,4.89996 C12.000001,4.59998 11.9000006,4.29993 11.7000008,4.09998 C11.6000013,4 11.3000002,3.79993 11,3.79993 Z M10.8999987,7.5 C10.7999992,7.5 10.6999989,7.5 10.5999994,7.59998 L8.5,8.69995 C8.1000004,8.89996 8,9.29993 8.1999989,9.69995 C8.3000002,9.99988 8.5999994,10.09998 8.8999996,10.09998 C9,10.09998 9.0999994,10.09998 9.1999989,10 L9.8000002,9.70001 L8.5,15.09998 C8.3999996,15.40002 8.5,15.70001 8.6999989,15.90002 C8.8000002,16 9,16.09998 9.1999989,16.09998 C9.3000002,16.09998 9.3999996,16.09998 9.5,16.00006 L11.8000002,15.09998 C12.1999998,14.90002 12.4000006,14.50006 12.1999998,14.09998 C12.0999994,13.80005 11.8000002,13.59998 11.5,13.59998 C11.3999987,13.59998 11.3000002,13.59998 11.1999998,13.70001 L10.3000002,14.09998 L11.6000013,8.50006 C11.7000008,8.20007 11.6000013,7.90002 11.3000002,7.70007 C11.1999998,7.5 11,7.5 10.8999987,7.5 Z"
}));

function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.25209477.svg";
export { ForwardRef as ReactComponent };